import instance from "../../axios/axios-user";
import { LikesProps } from "../../redux/slices/likes/Likes";
import { API_PATHS } from "../api_paths";

const dislikeAPost = (payload: LikesProps.dislikeAPostPayload) =>
  instance.post(API_PATHS.postLikes.dislikeAPost, payload);
const likeAPost = (payload: LikesProps.likeAPostPayload) =>
  instance.post(API_PATHS.postLikes.likeAPost, payload);
const getLikesAndDislikesCountForAPost = ({
  post_id,
}: LikesProps.getLikesAndDislikesCountForAPostPayload) =>
  instance.get(
    `${API_PATHS.postLikes.getLikesAndDislikesCountForAPost}/${post_id}`
  );
const removeLikeOrDislikeForAPost = (
  data: LikesProps.removeLikeOrDislikeForAPostPayload
) =>
  instance.delete(
    `${API_PATHS.postLikes.removeLikeOrDislikeForAPost}/${data.post_id}`,
    { data }
  );

export const POST_LIKES = {
  likeAPost,
  dislikeAPost,
  getLikesAndDislikesCountForAPost,
  removeLikeOrDislikeForAPost,
};
